import React, { useState, useEffect } from 'react';
import AppSidebar from '../components/Sidebar';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

import { Client, Databases, Storage, Query } from 'appwrite';

const client = new Client();
client
  .setEndpoint('https://cloud.appwrite.io/v1')
  .setProject('67fbee6a001260770104');

const databases = new Databases(client);
const storage = new Storage(client);

const DATABASE_ID = '68098bc80034d68e4e64';
const COLLECTION_ID = '68098bd900226cbeb1cd';
const BUCKET_ID = '680990d6000f00f9d400';

const ADMIN_EMAIL = 'opeyemi@gmail.com';

const ApprovePoems = () => {
  const { currentUser } = useAuth();
  const [pendingPoems, setPendingPoems] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect if not admin
    if (currentUser && currentUser.email !== ADMIN_EMAIL) {
      navigate('/dashboard');
      return;
    }
    
    if (currentUser && currentUser.email === ADMIN_EMAIL) {
      fetchPendingPoems();
    }
  }, [currentUser, navigate]); // Added dependency array

  const fetchPendingPoems = async () => {
    setLoading(true);
    try {
      const response = await databases.listDocuments(
        DATABASE_ID,
        COLLECTION_ID,
        [
          Query.equal('isApproved', false), // Only get unapproved poems
          Query.notEqual('userId', currentUser.uid), // Don't show admin's own poems
          Query.orderDesc('$createdAt') // Newest first
        ]
      );
      setPendingPoems(response.documents);
    } catch (error) {
      console.error('Error fetching pending poems:', error);
    } finally {
      setLoading(false);
    }
  };

  const getImagePreviewUrl = (fileId) => {
    if (!fileId) return null;
    try {
      return storage.getFileView(BUCKET_ID, fileId);
    } catch (error) {
      console.error('Error generating image URL:', error);
      return '';
    }
  };

  const handleApprove = async (id) => {
    try {
      await databases.updateDocument(DATABASE_ID, COLLECTION_ID, id, {
        isApproved: true,
      });
      // Remove the approved poem from the list
      setPendingPoems(pendingPoems.filter(poem => poem.$id !== id));
    } catch (error) {
      console.error('Error approving poem:', error);
    }
  };

  const handleReject = async (id) => {
    try {
      // Option 1: Delete the poem completely
      await databases.deleteDocument(DATABASE_ID, COLLECTION_ID, id);
      
      // Option 2: Mark as rejected (if you want to keep a record)
      // await databases.updateDocument(DATABASE_ID, COLLECTION_ID, id, {
      //   isRejected: true,
      // });
      
      // Remove from the list
      setPendingPoems(pendingPoems.filter(poem => poem.$id !== id));
    } catch (error) {
      console.error('Error rejecting poem:', error);
    }
  };

  if (!currentUser) return <div>Loading...</div>;
  if (currentUser.email !== ADMIN_EMAIL) return null;

  return (
    <div className="flex">
      <div className="sticky top-0 h-screen">
        <AppSidebar user={currentUser} />
      </div>
      <div className="flex-1 ml-20 md:ml-0 p-6 bg-gray-100 min-h-screen">
        <h1 className="text-2xl font-bold mb-4">Approve Poems</h1>
        <p className="mb-6 text-gray-600">Review and approve user-submitted poems. Only approved poems will be displayed on the website.</p>

        {loading ? (
          <div className="text-center py-10">
            <p>Loading pending poems...</p>
          </div>
        ) : pendingPoems.length === 0 ? (
          <div className="bg-white p-6 rounded-lg shadow-md text-center">
            <h2 className="text-xl font-semibold mb-2">No Pending Poems</h2>
            <p className="text-gray-600">All poems have been reviewed. Check back later for new submissions.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {pendingPoems.map((poem) => (
              <div key={poem.$id} className="bg-white rounded-lg shadow-md overflow-hidden border-l-4 border-yellow-500">
                {poem.imageId && (
                  <img
                    src={getImagePreviewUrl(poem.imageId)}
                    alt={poem.title}
                    className="h-48 w-full object-cover"
                    onError={(e) => e.target.src = 'https://via.placeholder.com/400x200?text=Image+Not+Found'}
                  />
                )}
                <div className="p-4">
                  <div className="flex justify-between items-center mb-2">
                    <h2 className="text-xl font-bold">{poem.title}</h2>
                    {poem.category && (
                      <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                        {poem.category}
                      </span>
                    )}
                  </div>
                  <p className="text-gray-700 mb-4 whitespace-pre-line">{poem.content}</p>
                  
                  <div className="flex justify-between items-center mt-4">
                    <div className="text-sm text-gray-600">
                      Submitted on {new Date(poem.createdAt).toLocaleDateString()}
                    </div>
                    <div className="flex space-x-2">
                      <button 
                        onClick={() => handleReject(poem.$id)} 
                        className="bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-600"
                      >
                        Reject
                      </button>
                      <button 
                        onClick={() => handleApprove(poem.$id)} 
                        className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
                      >
                        Approve
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ApprovePoems;